import { Context, Items } from "../context/UserDetails";
import { values } from "../types";
import { ImageComponent } from "./Tags/image";
import { useContext } from "react";

export const WasteComponent = ({
  _style = "grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4",
  items = [],
  click = true,
}: {
  _style?: string;
  Data?: Array<values>;
  items: Array<Items>;
  click?: boolean;
}): JSX.Element => {
  const contextValue = useContext(Context);
  const { selectedItems, setSelectedItems } = contextValue;

  const isSelected = (id: string | number | undefined): boolean => {
    if (!id) return false;
    return selectedItems.some((e) => e.id === id);
  };

  return (
    <section className={`${_style}`}>
      {items?.map((i, index) => {
        const { name, photo, id } = i;
        const selected = isSelected(id);

        return (
          <div
            className={`
              relative bg-white rounded-xl border transition-all duration-300 overflow-hidden
              ${selected 
                ? 'border-green-500 shadow-md' 
                : 'border-gray-100 hover:border-green-200 hover:shadow-sm'
              }
              ${click ? 'cursor-pointer' : ''}
            `}
            key={index}
            onClick={() => {
              if (!click) return;
              if (selected) {
                setSelectedItems(selectedItems.filter((d) => d.id !== id));
              } else {
                setSelectedItems([...selectedItems, i]);
              }
            }}
          >
            {/* Selection badge */}
            {selected && (
              <div className="absolute top-2 right-2 bg-green-500 text-white text-xs w-5 h-5 rounded-full flex items-center justify-center shadow-sm">
                ✓
              </div>
            )}

            <div className="p-3">
              <div className="aspect-square rounded-lg bg-gray-50 overflow-hidden">
                <ImageComponent 
                  _style="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105" 
                  src={photo as string} 
                />
              </div>
            </div>
            
            <div className="pb-3 text-center">
              <p className="text-sm font-medium text-gray-700 capitalize">
                {name}
              </p>
              <p className="text-xs text-gray-400 mt-0.5">
                {selected ? '✓ Added' : 'Click to select'}
              </p>
            </div>
          </div>
        );
      })}
    </section>
  );
};